import React from "react";
import "./Card.css";
function Card({ imageSrc, title, body }) {
  return (
    <div className="card">
      <img src={imageSrc} className="card__img" />
      <h2 className="card__title">{title}</h2>
      <p className="card__body">{body}</p>
    </div>
  );
}

export default Card;
